'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conductExperiment = conductExperiment;

var _wixExperiments = require('wix-experiments');

var _wixExperiments2 = _interopRequireDefault(_wixExperiments);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var experiments = new _wixExperiments2.default();

function conductExperiment(name) {
  return experiments.conduct(name, false).then(function (res) {
    return res.toString();
  }).then(function (res) {
    return res === 'true' || res === 'new';
  });
}